import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import CuidadosView from '../views/CuidadosView.vue'

const routes = [
  { path: '/', name: 'home', component: HomeView },
  { path: '/cuidados', name: 'cuidados', component: CuidadosView }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
